import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const NeutralColors = createInteractiveColorVars('neutral');
const NeutralColorsLightValues = Object.freeze({
    base: {
        default: '#F2F2F2',
        action: '#B4B4B4',
        active: '#F2F2F2',
        activeAction: '#B4B4B4',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
});
const NeutralColorsDarkValues = Object.freeze({
    base: {
        default: '#2F2F2F',
        action: '#080808',
        active: '#2F2F2F',
        activeAction: '#080808',
    },
    text: {
        default: '#FFFFFF',
        action: '#FFFFFF',
        active: '#FFFFFF',
        activeAction: '#FFFFFF',
    },
});

export { NeutralColors, NeutralColorsDarkValues, NeutralColorsLightValues };
